var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prodotti-page"},[_c('div',{staticClass:"cards-container"},_vm._l((_vm.prodotti),function(prodotto,index){return _c('div',{key:index,class:['card', index % 2 === 0 ? 'pari' : 'dispari']},[_c('img',{attrs:{"src":prodotto.foto,"alt":"prodotto.image"}}),_c('h3',[_vm._v(_vm._s(prodotto.titolo))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }